/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Import global styles
import "./src/styles/tailwind.css"
import "./src/styles/global.css"

// Scroll to top on every page navigation
export const shouldUpdateScroll = () => {
  return [0, 0];
};

// Meta Pixel – PageView en cada cambio de ruta (navegación SPA incluida)
export const onRouteUpdate = () => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView")
  }
}
